var exports = {
  "v_": "DiscoveryNavbar.module__navbar___M0ZlSD",
  "Bx": "DiscoveryNavbar.module__leftSection___M0ZlSD",
  "LY": "DiscoveryNavbar.module__leftSurface___M0ZlSD",
  "Gv": "DiscoveryNavbar.module__backButton___M0ZlSD",
  "dc": "DiscoveryNavbar.module__searchTitle___M0ZlSD",
  "$L": "DiscoveryNavbar.module__categoryTabs___M0ZlSD",
  "Wu": "DiscoveryNavbar.module__categoryTab___M0ZlSD",
  "KB": "DiscoveryNavbar.module__categoryTabActive___M0ZlSD" + " " + "DiscoveryNavbar.module__categoryTab___M0ZlSD",
  "uk": "DiscoveryNavbar.module__searchArea___M0ZlSD",
  "rm": "DiscoveryNavbar.module__searchForm___M0ZlSD",
  "qc": "DiscoveryNavbar.module__searchIcon___M0ZlSD",
  "Rt": "DiscoveryNavbar.module__searchInput___M0ZlSD",
};

module.exports = exports;
